import axios from "axios"
import { getToken } from "../../helpers"
import { getPreferredLanguage } from "../../helpers";
import { generateHash, generateMinifiedQuery } from "../../Graphql/hash";

export async function subscribeToNewsletter(userEmail, emailConsent = true){
    let url = `${window?.apiBaseUrl}/v2/identity/email/capture?device=web_browser`
    const token = await getToken();
    let data = {
      "emailConsent": emailConsent,
      "email": userEmail
    };
    let headers = {
      headers: { 
        'Authorization': token,
        'x-api-key': window?.xApiKey
      }
    };
    return axios.post(url, data, headers)
}

export function validateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email) return "Email is required";
  if (!emailRegex.test(email)) return "Invalid Email";
  return null;
}

/**
 * Function to check if a URL points to an image or video
 * @param {String} url
 * @returns {Array} - [urlType, urlExtension]
 */
export function getUrlType(url) {
  if(!url) return []
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
  const videoExtensions = ['mp4', 'mov', 'wmv', 'flv', 'avi', 'mkv', 'webm', 'mpeg', 'mpg'];
  const urlExtension = url?.split('.')?.pop()?.toLowerCase();
  let urlType = "other";
  if (imageExtensions.includes(urlExtension)) {
    urlType =  'image';
  } else if (videoExtensions.includes(urlExtension)) {
    urlType = 'video';
  } 
  return [urlType, urlExtension]
}


// to check user type
export const getUserSubscriptionType = (user) => {
  if (!user) return "free";
  if (user?.subscription?.subscriptionStatus === "SUSPENDED") return "cancelled";
  if (user?.tveMetadata?.tveProvider || user?.tveProvider) return "tve";
  if (user?.subscription?.subscriptionPlanInfo?.renewalCycleType === "MONTH") return "monthly";
  if (user?.subscription?.subscriptionPlanInfo?.renewalCycleType === "YEAR") return "annually";
  return "email";
};

// graph QL for User Upgrade
const SplashUserUpgradeQuery = `query ($device: Device!, $domain: String, $siteId: String, $country: String, $language: String) {
  bootstrap(device: $device, domain: $domain, siteId: $siteId, country: $country, language: $language) {
    appcmsMain {
      splashConfig {
       userUpgrade {
         isActive
         userStates {
           type
           isActive
           mainContainerBgColor
           heading
           headingColor
           subtitle
           subtitleColor
           ctaButtonText
           ctaButtonTextColor
           ctaButtonLink
           ctaButtonBgColor
           userUpgradeImageUrl
           supportedPlatforms
           frequency
           frequencyMultiplier
           pagePath
           fontSettings {
            title {
              fontFamilyName
              fontFamilyUrl
              fontSize
              fontWeight
            }
            button {
              fontFamilyName
              fontFamilyUrl
              fontSize
              fontWeight
            }
            trayItemTitle {
              fontFamilyName
              fontFamilyUrl
              fontSize
              fontWeight
            }
          }
         }
       }
      }
    }
  }
}`

const minifiedUserUpgradeQuery = generateMinifiedQuery(SplashUserUpgradeQuery);
const siteUserUpgradeQuerySHA = generateHash(minifiedUserUpgradeQuery);

export const getUserUpgradeData = async () => {
  if (typeof window === 'undefined') return;
  let apiConfig= window.app_data?.appcmsMain?.apiConfig;
  let baseUrl = apiConfig?.apiBaseCachedUrl || apiConfig?.apiBaseUrl;
  let endpoint = `${baseUrl}/graphql`;

  const variables = {
    siteId: window.app_data?.appcmsMain?.id,
    device: "WEB",
    country: null,
    language: getPreferredLanguage() || "en",
  };

  const url = endpoint + "?extensions=" + encodeURIComponent(JSON.stringify({ persistedQuery: { version: 1, sha256Hash: siteUserUpgradeQuerySHA }, })) +
    "&variables=" + encodeURIComponent(JSON.stringify(variables));

  try {
    const response = await axios.get(url);
    const res = response?.data;
    // if persisted query not found
    if (res.errors) {
      if (res?.errors?.[0]?.message === "PersistedQueryNotFound") {
        return cacheUserUpgradeData(variables);
      }
    } else {
      return res?.data?.bootstrap?.appcmsMain?.splashConfig;
    }
  } catch (err) {
    console.error("GraphQL request failed:", err?.response?.data || err);
    return null;
  }
};

export async function cacheUserUpgradeData(variables,) {
  let apiConfig= window.app_data?.appcmsMain?.apiConfig;
  let baseUrl = apiConfig?.apiBaseUrl;
  let endpoint = `${baseUrl}/graphql`;
  let headers = {
        "X-Forwarded-For": window?.ip || "",
    };


  const finalPayload = {
    "query": minifiedUserUpgradeQuery,
    "variables": variables,
    "extensions": { "persistedQuery": { "version": 1, "sha256Hash": siteUserUpgradeQuerySHA } }
  };

  try {
    const response = await axios.post(endpoint, finalPayload,headers)
    return response?.data?.data?.bootstrap?.appcmsMain?.splashConfig;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);
    } else {
      console.log(error, "Error");
    }
    return null;
  }
}